function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.3 5.71003C17.91 5.32003 17.28 5.32003 16.89 5.71003L12 10.59L7.11003 5.70003C6.72003 5.31003 6.09003 5.31003 5.70003 5.70003C5.31003 6.09003 5.31003 6.72003 5.70003 7.11003L10.59 12L5.70003 16.89C5.31003 17.28 5.31003 17.91 5.70003 18.3C6.09003 18.69 6.72003 18.69 7.11003 18.3L12 13.41L16.89 18.3C17.28 18.69 17.91 18.69 18.3 18.3C18.69 17.91 18.69 17.28 18.3 16.89L13.41 12L18.3 7.11003C18.68 6.73003 18.68 6.09003 18.3 5.71003Z",
  fill: "#303030"
});
function SvgClear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClear);
export default __webpack_public_path__ + "static/media/clear.eb368b33caf62eff80200f9223cf8179.svg";
export { ForwardRef as ReactComponent };